import Content from '../components/Content';
import CreateAutomation from '../components/automation/CreateAutomation';
import AutomationStore from '../stores/AutomationStore';

const AutomationAction = ({userStore}) => {
  const myAutomationStore = new AutomationStore(userStore);

  return (
    <Content title="Interações com usuários fictícios" userStore={userStore}>
      <CreateAutomation automationStore={myAutomationStore} />
    </Content>
  )
}

export default AutomationAction
